import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77cf4a91"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "comment-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item_comment = _resolveComponent("item-comment")!
  const _component_app_message_input = _resolveComponent("app-message-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_item_comment, {
      class: _normalizeClass(["mb-20", { 'mt-20': _ctx.popUp }])
    }, null, 8, ["class"]),
    _createVNode(_component_item_comment, { class: "mb-20" }),
    _createVNode(_component_item_comment, { class: "mb-20" }),
    _createVNode(_component_item_comment, { class: "mb-20" }),
    _createVNode(_component_item_comment, { class: "mb-20" }),
    _createVNode(_component_item_comment),
    _hoisted_2,
    _createVNode(_component_app_message_input, {
      onSend: _ctx.sendMessage,
      class: _normalizeClass(["msg", { 'popUp': _ctx.popUp }])
    }, null, 8, ["onSend", "class"])
  ]))
}